import { Box } from "@material-ui/core";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { usePayDepositStyles } from "./payDeposit.styles";
import { CheckoutForm } from "./CheckoutForm";
import { useConfig } from "../../../../components/config/ConfigContext";
import { FEATURE_NAME } from "./paymentConstants";

export const TabPayDeposit = ({ quoteId }: { quoteId: string }) => {
  const { isMoreThanSm } = useBreakpoint();
  const classes = usePayDepositStyles();
  const { isFeatureEnabled, getFeatureConfig } = useConfig();

  const stripePromise = loadStripe(getFeatureConfig(FEATURE_NAME)?.StripeKey);

  if (!isFeatureEnabled(FEATURE_NAME)) return null;

  return (
    <Box width={"100%"} className={classes.root}>
      <Box className={classes.stripeLogo}>
        <img src="images/stripe.png" alt="stripe" width={"100%"} />
      </Box>
      <Box width={"100%"} padding={isMoreThanSm ? "8px 35px" : 0}>
        <Elements stripe={stripePromise}>
          <CheckoutForm quoteId={quoteId} />
        </Elements>
      </Box>
    </Box>
  );
};
